import styled from 'styled-components'
import { themeContract } from './SpecialOffer.theme.contract'

const Placeholder = styled.a`
  font-size: 12px;
  background: ${props => props.theme.color.palette[themeContract[props.theme.channel].placeholder.background]};
  width: 75px;
  height: 75px;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
`

const EndDate = styled.p`
  color: ${props => props.theme.color.monochrome.dark};
  flex: 1;
  padding: 10px 0;
`

const Item = styled.span`
  margin-right: 25px;
  margin-top: 30px;
`

const Pricing = styled.div`
  justify-content: space-between;
  width: 50%;
  color: ${props => props.theme.color.palette[themeContract[props.theme.channel].pricing.color]};
  text-transform: uppercase;
  font-weight: ${props => props.theme.font.weight.bold};
`

const LinkButton = styled.a`
  width: 100%;
`

const Container = styled.div`
  justify-content: space-between;
`

export { Placeholder, EndDate, Item, Pricing, LinkButton, Container }
